import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-report",
  templateUrl: "./med-icon-report.component.html",
})
export class MedIconReportComponent extends SvgMixinComponent {}
